module.exports = __webpack_public_path__ + "static/media/mail.64876c3e.png";